import React from 'react';
import './CSS/PolicyPage.css'; // We'll use a shared CSS file for all policy pages

const Terms = () => {
  return (
    <div className="policy-page container">
      <h1>Terms & Conditions</h1>
      
      <div className="policy-section">
        <h2>1. Introduction</h2>
        <p>Welcome to Madurai Special! These terms and conditions outline the rules and regulations for the use of our food delivery service. By accessing this app and placing an order, we assume you accept these terms and conditions. Do not continue to use Madurai Special if you do not agree to all of the terms and conditions stated on this page.</p>
      </div>

      <div className="policy-section">
        <h2>2. Orders and Payment</h2>
        <p>All orders are subject to availability. We reserve the right to refuse an order for any reason. All payments must be made at the time of ordering through our integrated payment gateway. Prices for our products are subject to change without notice.</p>
      </div>

      <div className="policy-section">
        <h2>3. User Accounts</h2>
        <p>To access certain features of the service, you may be required to create an account. You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.</p>
      </div>
      
       <div className="policy-section">
        <h2>4. Limitation of Liability</h2>
        <p>In no event shall Madurai Special, nor any of its officers, directors, and employees, be held liable for anything arising out of or in any way connected with your use of this service. We provide our service on an "as is" and "as available" basis.</p>
      </div>
    </div>
  );
};

export default Terms;